import { ImageViewer as DefaultImageViewer } from './ImageViewer';
import { withReduxState } from './withReduxState';

export const ImageViewer = withReduxState(DefaultImageViewer);
